import { withRouter } from 'react-router-dom';
import { Box, Grid, Typography } from '@material-ui/core';
import styles from './feedback.style';
import UserInfo from './UserInfo.component';
import React, { useState, useRef, useEffect } from 'react';
import { MobileStepper } from '@material-ui/core';
import { AppStepperButton } from '../profiler/InputComponents';
import Demographics from './Demographic.component';
import { repliValidator } from '../../../components';
import AppQuestions from './AppQuestions.component';
import logo from "../../../images/logo_full.png";
import { MobileRegularPage } from '../../../components';
import Alert from '@material-ui/lab/Alert';
import { AppButton } from "../components/InputComponents";
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js';


const cookies = new Cookies();

const FeedBack = (props) => {

    const classes = styles();
    const [activeStep, setActiveStep] = useState(0);
    const totalSteps = 3;

    const [submitted, setSubmitted] = useState(false);
    const [userInfoSubmitted, setUserInfoSubmitted] = useState(false);
    const [demoGraphicsSubmitted, setDemoGraphicsSubmitted] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const [email, setEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [age, setAge] = useState();
    const [role, setRole] = useState('');
    const [otherRole, setOtherRole] = useState('');
    const [canContact, setCanContact] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);

    const [rljPosition, setRLJPosition] = useState('');
    const [satisfiedRespWithRLJ, setsatisfiedRespWithRLJ] = useState('');
    const [satisfiedReasonWithRLJ, setSatisfiedReasonWithRLJ] = useState('');
    const [notSatisfiedRespWithRLJ, setNotSatisfiedRespWithRLJ] = useState('');
    const [notSatisfiedReasonWithRLJ, setNotSatisfiedReasonWithRLJ] = useState('');

    const [appRating, setAppRating] = useState(null);
    const [websiteRating, setwebsiteRating] = useState(null);
    const [canRecommendRepLI, setCanRecommendRepLI] = useState('');
    const [recommendRepLITo, setRecommendRepLITo] = useState([]);
    const [recommendRepLIToOtherResp, setRecommendRepLIToOtherResp] = useState('');
    const [isRLJMappedCorrectly, setIsRLJMappedCorrectly] = useState('');
    const [mappedRLJOtherResp, setMappedRLJOtherResp] = useState('');
    const [issues, setIssues] = useState('');
    const [didRepLIEnvisionRLG, setDidRepLIEnvisionRLG] = useState('');
    const [isRepLIHelpfulForSeeingRLG, setIsRepLIHelpfulForSeeingRLG] = useState('');
    const [featuresFindHelpfulForApp, setFeaturesFindHelpfulForApp] = useState([]);
    const [otherFeaturesFindHelpfulForApp, setOtherFeaturesFindHelpfulForApp] = useState('');
    const [featuresFindHelpfulForWebsite, setFeaturesFindHelpfulForWebsite] = useState([]);
    const [otherFeaturesFindHelpfulForWebsite, setOtherFeaturesFindHelpfulForWebsite] = useState('');
    const [otherFeedbackSuggested, setOtherFeedbackSuggested] = useState('');

    const [saveResult, setSaveResult] = useState();

    const validator = useRef(repliValidator({
        validators: {
            field_req: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === 'Other') return val !== '';
                    return true;
                },
                required: true
            },
            issues_field_req: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === 'There were a few errors' || params[0] === 'My journey did not map at all') return val !== '';
                    return true;
                },
                required: true
            },
            repli_envision_goals: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === "Not Yet" || params[0] === "I'm Ready" || params[0] === "I'm In It" || params[0] === "Not Interested") return val !== '';
                    return true;
                },
                required: true
            },
            was_repli_helpful_in_seeing_journey: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === "I'm Done" || params[0] === "I'm In It" || params[0] === "Not Interested") return val !== '';
                    return true;
                },
                required: true
            },
            other_features_find_helpful_for_app: {
                message: 'The Other features find helpful field is required',
                rule: (val, params, validator) => {
                    if (params.some(x => x === "Other")) return val !== '';
                    return true;
                },
                required: true
            },
            recommend_repli_to: {
                message: 'The recommend RepLI to field is required',
                rule: (val, params, validator) => {
                    if (params[0] === "yes") return val !== '';
                    return true;
                },
                required: true
            },
            recommend_repli_to_others: {
                message: 'The recommend RepLI to others field is required',
                rule: (val, params, validator) => {
                    if (params[0] === "yes" && params.some(x => x === "Other")) return val !== '';
                    return true;
                },
                required: true
            }
        }
    }));

    const userInformationValidator = useRef(repliValidator({
        validators: {
            field_req: {
                message: 'This field is required',
                rule: (val, params, validator) => {
                    if (params[0] === 'Other') return val !== '';
                    return true;
                },
                required: true
            }
        }
    }));

    const demoGraphicValidator = useRef(repliValidator());


    useEffect(() => {
        const getFeedBack = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_FEEDBACK}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (response.ok) {
                    setIsSuccess(true);
                }

                let email = localStorage.getItem('email');
                const bytes = CryptoJS.AES.decrypt(email, process.env.REACT_APP_SECRET_KEY);
                const decryptEmail = bytes.toString(CryptoJS.enc.Utf8);

                let userData = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER_GETBYEMAIL}/${decryptEmail}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                let json = await userData.json();
                if (!userData.ok) {
                    setIsError(true);
                    return;
                };
                setEmail(json.email);
                let userName = json.firstName + " " + json.lastName;
                setUserName(userName);
            } catch (error) {
                console.log(error);
            };
        }

        getFeedBack();
    }, [])


    const handleBackClick = () => {
        setActiveStep(activeStep - 1);
    };

    const handleNextClick = () => {
        if (activeStep === 0) {
            setUserInfoSubmitted(true);
            const isValid = userInformationValidator.current.allValid();
            if (!isValid) {
                userInformationValidator.current.showMessages();
            }
            else {
                setActiveStep(activeStep + 1);
            }
        }

        if (activeStep === 1) {
            setDemoGraphicsSubmitted(true);
            const isValid = demoGraphicValidator.current.allValid();
            if (!isValid) {
                demoGraphicValidator.current.showMessages();
            }
            else {
                setActiveStep(activeStep + 1);
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        }
    };


    const validateEmail = (e) => {
        let email = e.target.value;
        setEmail(email)
        if (email && new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(email) === false) {

            setIsValidEmail(false)
        }
        else {
            setIsValidEmail(true);
        }
    }

    const handleRoleChange = (e) => {
        if (e.target.value !== 'Other') {
            setOtherRole('');
        }
        setRole(e.target.value)
    }

    const handleRLJMappedCorrectly = (e) => {
        if (e.target.value === 'Other') {
            setIssues('');
        }
        else if (e.target.value === 'There were a few errors' || e.target.value === 'My journey did not map at all') {
            setMappedRLJOtherResp('');
        }
        setIsRLJMappedCorrectly(e.target.value)
    }

    const handleFeaturesFindHelpfulForAppChange = (e) => {
        setFeaturesFindHelpfulForApp(e.target.value);
        if (featuresFindHelpfulForApp.some(x => x !== "Other")) {
            setOtherFeaturesFindHelpfulForApp('');
        }
    }

    const handleRecommendRepLIChange = (e) => {
        setRecommendRepLITo(e.target.value);
        if (recommendRepLITo.some(x => x !== "Other")) {
            setRecommendRepLIToOtherResp('');
        }
    }

    const handleInputChange = (e, InputType) => {
        const validInput = new RegExp(/[a-zA-Z0-9][\\sa-zA-Z0-9]{0,40}/);
        if (validInput.test(e.target.value) || e.target.value === '') {
            if (InputType === "Other Role")
                setOtherRole(e.target.value);
            else if (InputType === "Satisfied Reason With RLJ")
                setSatisfiedReasonWithRLJ(e.target.value);
            else if (InputType === "Not Satisfied Reason With RLJ")
                setNotSatisfiedReasonWithRLJ(e.target.value);
            else if (InputType === "Mapped RLJ Other Response")
                setMappedRLJOtherResp(e.target.value);
            else if (InputType === "RLJ Issues")
                setIssues(e.target.value);
            else if (InputType === "Other features find helpful for App")
                setOtherFeaturesFindHelpfulForApp(e.target.value);
            else if (InputType === "Other features find helpful for Website")
                setOtherFeaturesFindHelpfulForWebsite(e.target.value);
            else if (InputType === "Other Feedback")
                setOtherFeedbackSuggested(e.target.value);
            else if (InputType === "Recommend RepLI to Others Response")
                setRecommendRepLIToOtherResp(e.target.value);
        }
    }

    const submitClick = async e => {
        e.preventDefault();
        setSubmitted(true);
        const isValid = validator.current.allValid();
        if (!isValid || appRating === null || websiteRating === null) {
            validator.current.showMessages();
            return;
        }

        let userInfo = {
            name: userName,
            email: email,
            age: parseInt(age),
            role: role,
            otherRole: otherRole,
            canContact: canContact
        };

        let demoGraphics = {
            rljPosition: rljPosition,
            satisfiedRespWithRLJ: satisfiedRespWithRLJ,
            satisfiedReasonWithRLJ: satisfiedReasonWithRLJ,
            notSatisfiedRespWithRLJ: notSatisfiedRespWithRLJ,
            notSatisfiedReasonWithRLJ: notSatisfiedReasonWithRLJ,
        };

        let appQuestionstions = {
            appRating: parseInt(appRating),
            websiteRating: parseInt(websiteRating),
            canRecommendRepLI: canRecommendRepLI,
            recommendRepLITo: recommendRepLITo,
            recommendRepLIToOtherResp: recommendRepLIToOtherResp,
            isRLJMappedCorrectly: isRLJMappedCorrectly,
            mappedRLJOtherResp: mappedRLJOtherResp,
            issues: issues,
            didRepLIEnvisionRLG: didRepLIEnvisionRLG,
            isRepLIHelpfulForSeeingRLG: isRepLIHelpfulForSeeingRLG,
            featuresFindHelpfulForApp: featuresFindHelpfulForApp,
            otherFeaturesFindHelpfulForApp: otherFeaturesFindHelpfulForApp,
            featuresFindHelpfulForWebsite: featuresFindHelpfulForWebsite,
            otherFeaturesFindHelpfulForWebsite: otherFeaturesFindHelpfulForWebsite,
            otherFeedbackSuggested: otherFeedbackSuggested
        };

        try {
            let res = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH}/app/me`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            let json = await res.json();
            let id = json._id;

            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_FEEDBACK}`, {
                method: 'post',
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                },
                body: new URLSearchParams({
                    id: id,
                    userInfo: JSON.stringify(userInfo),
                    demographicInfo: JSON.stringify(demoGraphics),
                    appInfo: JSON.stringify(appQuestionstions)
                })
            });
            if (!response.ok) {
                setIsError(true);
                setSaveResult({
                    severity: 'error',
                    message: json.message
                });
                return;
            }
            else {
                setIsSuccess(true);
                setIsError(false);
            }

        } catch (error) {
            console.log(error);
            setIsError(true);
            setSaveResult({
                severity: 'error',
                message: error
            });
        }
    }

    return (
        <Grid>
            <Box className={classes.logo} style={{ textAlign: "center" }}>
                <img src={logo} alt="logo" />
            </Box>
            {!isSuccess &&
                <Grid>

                    {saveResult && isError &&
                        <Alert severity={saveResult.severity}>{saveResult.message}</Alert>
                    }

                    {activeStep === 0 &&
                        <UserInfo
                            onEmailChange={validateEmail}
                            email={email}
                            isValidEmail={isValidEmail}
                            userName={userName}
                            onUserNameChange={e => setUserName(e.target.value)}
                            age={age}
                            onAgeChange={e => setAge(e.target.value)}
                            role={role}
                            onRoleChange={handleRoleChange}
                            otherRole={otherRole}
                            onOtherRoleChange={(e, userOtherRole) => handleInputChange(e, userOtherRole)}
                            canContact={canContact}
                            canContactChange={e => setCanContact(e.target.value)}
                            submitted={userInfoSubmitted}
                            validator={userInformationValidator.current}
                            render={userInformationValidator.current.purgeFields()}
                        />
                    }

                    {activeStep === 1 &&
                        <Demographics
                            rljPosition={rljPosition}
                            onRLJPositionChange={e => setRLJPosition(e.target.value)}
                            satisfiedRespWithRLJ={satisfiedRespWithRLJ}
                            onSatisfiedRespWithRLJChange={e => setsatisfiedRespWithRLJ(e.target.value)}
                            satisfiedReasonWithRLJ={satisfiedReasonWithRLJ}
                            onSatisfiedReasonWithRLJChange={(e, satisfiedReason) => handleInputChange(e, satisfiedReason)}
                            notSatisfiedRespWithRLJ={notSatisfiedRespWithRLJ}
                            onNotSatisfiedRespWithRLJChange={e => setNotSatisfiedRespWithRLJ(e.target.value)}
                            notSatisfiedReasonWithRLJ={notSatisfiedReasonWithRLJ}
                            onNotSatisfiedReasonWithRLJChange={(e, notSatisfiedReason) => handleInputChange(e, notSatisfiedReason)}
                            submitted={demoGraphicsSubmitted}
                            validator={demoGraphicValidator.current}
                            render={demoGraphicValidator.current.purgeFields()}
                        />
                    }

                    {activeStep === 2 &&
                        <AppQuestions
                            appRating={appRating}
                            onAppRatingChange={e => setAppRating(e.target.value)}
                            websiteRating={websiteRating}
                            onWebsiteRatingChange={e => setwebsiteRating(e.target.value)}
                            canRecommendRepLI={canRecommendRepLI}
                            onCanRecommendRepLIChange={e => setCanRecommendRepLI(e.target.value)}
                            recommendRepLITo={recommendRepLITo}
                            onRecommendRepLIToChange={handleRecommendRepLIChange}
                            recommendRepLIToOtherResp={recommendRepLIToOtherResp}
                            onRecommendRepLIToOtherRespChange={(e, recommendRepLIToOthers) => handleInputChange(e, recommendRepLIToOthers)}
                            isRLJMappedCorrectly={isRLJMappedCorrectly}
                            onIsRLJMappedCorrectlyChange={handleRLJMappedCorrectly}
                            mappedRLJOtherResp={mappedRLJOtherResp}
                            onMappedRLJOtherRespChange={(e, mappedOtherResp) => handleInputChange(e, mappedOtherResp)}
                            issues={issues}
                            onIssuesChange={(e, issuesChange) => handleInputChange(e, issuesChange)}
                            didRepLIEnvisionRLG={didRepLIEnvisionRLG}
                            onDidRepLIEnvisionRLGChange={e => setDidRepLIEnvisionRLG(e.target.value)}
                            isRepLIHelpfulForSeeingRLG={isRepLIHelpfulForSeeingRLG}
                            onIsRepLIHelpfulForSeeingRLGChange={e => setIsRepLIHelpfulForSeeingRLG(e.target.value)}
                            rljPosition={rljPosition}
                            featuresFindHelpfulForApp={featuresFindHelpfulForApp}
                            onFeaturesFindHelpfulForAppChange={handleFeaturesFindHelpfulForAppChange}
                            otherFeaturesFindHelpfulForApp={otherFeaturesFindHelpfulForApp}
                            onOtherFeaturesFindHelpfulForAppChange={(e, otherFeaturesHelpfulForApp) => handleInputChange(e, otherFeaturesHelpfulForApp)}
                            featuresFindHelpfulForWebsite={featuresFindHelpfulForWebsite}
                            onFeaturesFindHelpfulForWebsiteChange={e => setFeaturesFindHelpfulForWebsite(e.target.value)}
                            otherFeaturesFindHelpfulForWebsite={otherFeaturesFindHelpfulForWebsite}
                            onOtherFeaturesFindHelpfulForWebsiteChange={(e, otherFeatureHelpfulForWebsite) => handleInputChange(e, otherFeatureHelpfulForWebsite)}
                            otherFeedbackSuggested={otherFeedbackSuggested}
                            onOtherFeedbackSuggestedChange={(e, otherFeedback) => handleInputChange(e, otherFeedback)}
                            render={validator.current.purgeFields()}
                            submitted={submitted}
                            validator={validator.current}
                        />
                    }

                    <Box className={classes.regularFooter}>
                        <MobileStepper
                            variant="dots"
                            className={classes.justifyContentCenter}
                            steps={totalSteps}
                            position="static"
                            activeStep={activeStep}
                            style={{ backgroundColor: 'rgba(0,0,0,0)' }}
                        />

                        <Box display="flex" justifyContent="space-between" width="100%">
                            {activeStep < 1 &&
                                <Box flexGrow={1} pr={1}>
                                    <AppStepperButton
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size="large"
                                        component={Link}
                                        to="/app/dashboard"
                                        onClick={props.scrollToTop}
                                    >
                                        Back To Dashboard
                                    </AppStepperButton>
                                </Box>
                            }
                            {activeStep > 0 &&
                                <Box flexGrow={1} pr={1}>
                                    <AppStepperButton
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size="large"
                                        onClick={handleBackClick}
                                    >
                                        Previous
                                    </AppStepperButton >
                                </Box>
                            }
                            {activeStep < 2 &&
                                <Box flexGrow={1} pl={1}>
                                    <AppStepperButton
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size="large"
                                        onClick={handleNextClick}
                                    >
                                        Next
                                    </AppStepperButton >
                                </Box>
                            }



                            {activeStep === 2 &&
                                <Box flexGrow={1} pl={1}>
                                    <AppStepperButton
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size="large"
                                        onClick={submitClick}
                                    >
                                        Submit
                                    </AppStepperButton >
                                </Box>
                            }
                        </Box>
                    </Box>
                </Grid >
            }

            {isSuccess &&
                <MobileRegularPage>

                    <Box style={{ marginTop: "20px" }}>
                        <Typography variant="h5" className='mt-5' >THANK YOU !</Typography>
                        <Typography className='mt-5' >For your valuable feedback .</Typography>
                    </Box>

                    <AppButton
                        style={{ marginTop: "20px" }}
                        variant="contained"
                        color="secondary"
                        fullWidth
                        size="large"
                        component={Link}
                        to="/app/dashboard"
                        onClick={props.scrollToTop}
                    >
                        Back To Dashboard
                    </AppButton>

                </MobileRegularPage>


            }
        </Grid>

    );
}

export default withRouter(FeedBack);